import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyRiunioniService {
    static byAzienda = (id_azienda, anno = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/riunioni/byAzienda`;
            const payload = { id_azienda };
            if (anno) payload.anno = anno;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static compliance = (id_azienda, anno = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/riunioni/compliance`;
            const payload = { id_azienda };
            if (anno) payload.anno = anno;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/riunioni/create`;
        return ApiService.postFormData(url, formData);
    };

    static deleteRiunione = (id_riunione) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/riunioni/delete`;
            ApiService.postRequest(resolve, reject, url, { id_riunione });
        });
    };

    static download = (id_riunione, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/riunioni/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_riunione, filename });
        });
    };
}
